import { addDays, differenceInDays } from 'date-fns';
import { APISubscription } from '../../../../../typings/Subscription.interface';

export function useMemberTrial(subscription?: APISubscription) {
  if (!subscription) return {};

  // Outpost orgs get their seats from their Outpost entitlement, so the Event
  // Gateway member trial must never gate them. The backend already exempts
  // Outpost orgs from member limits (server `addMembers`, via the
  // `has_outpost_plan` short-circuit); mirror that here so a lapsed EG member
  // trial doesn't wrongly lock down member management on an Outpost org. Note
  // the active-trial state is intentionally left intact: an Outpost org can
  // still opt into the EG member trial to grant its members Event Gateway
  // access for the trial window.
  const has_outpost_plan = !!subscription?.outpost_plan;

  const member_trial_ends_at =
    subscription?.team_member_trial_start_at &&
    addDays(new Date(subscription.team_member_trial_start_at), 14);
  const is_member_trial_active =
    subscription?.plan === 'free' && member_trial_ends_at && member_trial_ends_at > new Date();
  const member_trial_left_days =
    is_member_trial_active && differenceInDays(member_trial_ends_at, new Date());
  const is_member_trial_expired =
    !has_outpost_plan &&
    subscription?.plan === 'free' &&
    !!subscription?.team_member_trial_start_at &&
    !is_member_trial_active;

  return {
    is_member_trial_active,
    member_trial_left_days,
    is_member_trial_expired,
  };
}
